export default __webpack_public_path__ + "static/media/speech-bubble.ff0e4f29.svg";